export default {
  sui: {
    loading: {
      text: 'Wird geladen'
    },
    form: {
      more: 'Mehr',
      zhankai: 'Mehr',
      shouqi: 'Ausblenden',
      query: 'Suchen',
      reset: 'Zurücksetzen',
      add: 'Hinzufügen',
      update: 'Aktualisieren',
      delete: 'Löschen',
      required: 'ist erforderlich',
      export: {
        export: 'Exportieren',
        selectFormat: 'Format auswählen',
        selectedRow: '{key} Zeilen ausgewählt',
        selectedTotal: '{key} Zeilen insgesamt, exportieren',
        line: 'Zeile'
      },
      please: {
        input: 'eingeben ',
        select: 'auswählen '
      },
      time: {
        start: 'Startzeit',
        end: 'Endzeit',
        to: 'Bis'
      },
      date: {
        start: 'Startdatum',
        end: 'Enddatum'
      },
      upload: {
        triggerText: 'Hochladen'
      },
      expand: 'Erweitern',
      multiple: 'Mehrfach',
      cols_hide: 'Spalteneinstellung'
    },
    table: {
      handle: 'Aktion',
      sum: 'Summe',
      index: 'Index',
      zanwushuju: 'Keine Daten',
      queding: 'OK',
      quxiao: 'Abbrechen',
      lie: 'Spalte',
      yiyincang: 'Ausgeblendet',
      gong: 'Gesamt'
    },
    tableEdit: {
      tip1: 'Die Daten befinden sich noch im Bearbeitungsmodus und können nicht gespeichert werden!',
      tip2: 'Möchten Sie die Daten wirklich löschen?',
      baocun: 'Speichern',
      chongzhi: 'Zurücksetzen',
      xinzeng: 'Hinzufügen',
      guanbituozhuai: 'Drag & Drop schließen',
      kaiqituozhuai: 'Drag & Drop öffnen',
      caozuo: 'Aktion',
      queren: 'OK',
      bianji: 'Bearbeiten',
      shanchu: 'Löschen',
      tishi: 'Hinweis'
    },
    list: {
      yi_xuan_ze: 'ausgewählt',
      tiao: 'Einträge',
      gong: 'Gesamt',
      mei_you_geng_duo: 'Keine weiteren Einträge',
      zan_wu_shu_ju: 'Noch keine Daten ausgewählt'
    },
    bond: {
      zheng_quan_dai_ma: 'Anleihecode',
      zheng_quan_ming_cheng: 'Anleihename',
      zan_wu_shu_ju: 'Keine Daten',
      qu_xiao_qing_qiu: 'Anfrage wurde abgebrochen'
    },
    dialog: {
      ok: 'OK',
      cancel: 'Abbrechen'
    },
    page: {
      add: {
        success: '[{key}] erfolgreich hinzugefügt'
      },
      delete: {
        title: '{key}-Löschen',
        confirm: '[{key}] wirklich löschen?',
        success: '[{key}] erfolgreich gelöscht'
      },
      update: {
        success: '[{key}] erfolgreich aktualisiert',
        noChange: 'Keine Änderungen, nicht gespeichert'
      }
    },
    tablePage: {
      export: {
        tip1: 'Bitte geben Sie die korrekte Zeilennummer ein',
        tip2: 'Exporttyp',
        tip3: 'Auswählen',
        tip4: 'Exportieren als',
        tip5: 'Bitte wählen Sie den Exportdateityp',
        lie: 'Spalte',
        hang: 'Zeile',
        shi: 'Ja',
        fou: 'Nein',
        daochu: 'Exportieren',
        wancheng: 'Bestätigen',
        quxiao: 'Abbrechen',
        gong: 'Gesamt',
        type1: 'Sequentieller Export',
        type2: 'Manueller Export',
        daochu_geshi: 'Exportdateityp'
      }
    },
    editlist: {
      caozuo: 'Aktion',
      shanchu: 'Löschen',
      xinzeng: 'Hinzufügen'
    },
    upload: {
      tip1: 'Drücken Sie die Entf-Taste zum Löschen'
    },
    uploadPro: {
      tip1: 'Websocket-Verbindung verloren, versuche erneut zu verbinden',
      tip2: 'Verbindung unterbrochen'
    },
    select: {
      jiazaizhong: 'Wird geladen',
      wupipeishuju: 'Keine übereinstimmenden Daten',
      wushuju: 'Keine Daten',
      quanxuan: 'Alle auswählen',
      fanxuan: 'Auswahl umkehren'
    },
    transfer: {
      tip1: 'Suchen',
      liebiao1: 'Liste 1',
      liebiao2: 'Liste 2'
    },
    treeGrid: {
      caozuolan: 'Aktion'
    },
    empty: {
      zanwuneirong: 'Keine Daten'
    },
    valid: {
      char: 'Zeichen',
      len1: 'Bitte {p1} eingeben',
      len2: 'Bitte {p1} bis {p2} eingeben',
      num: 'Ziffer',
      pInt: 'Positive Ganzzahl',
      npInt: 'Nicht-positive Ganzzahl',
      nInt: 'Negative Ganzzahl',
      nNInt: 'Nicht-negative Ganzzahl',
      int: 'Ganzzahl',
      pFNum: 'Positive Dezimalzahl',
      nFNum: 'Negative Dezimalzahl',
      num_: 'Ziffer(-,_)',
      en: 'Englische Zeichen',
      en_: 'Englische Zeichen(-,_)',
      ch: 'Chinesische Zeichen',
      ch_: 'Chinesische Zeichen(-,_)',
      nch: 'Nicht-chinesische Zeichen',
      numEn: 'Ziffer oder englische Zeichen',
      numEn_: 'Ziffer oder englische Zeichen(-,_)',
      chEnNum: 'Ziffer, englische oder chinesische Zeichen',
      chEnNum_: 'Ziffer, englische oder chinesische Zeichen(-,_)',
      phone: 'Telefonnummer',
      email: 'E-Mail-Adresse',
      idcard: 'Personalausweisnummer',
      url: 'URL',
      reg: 'Bitte korrekt eingeben',
      version: 'Versionsnummer',
      uri: 'URI',
      datasource: 'Datenquelle',
      intRegion: 'Ganzzahl zwischen {p1} und {p2}',
      floatRegion: 'Dezimalzahl zwischen {p1} und {p2}'
    },
    timerange: {
      jue_dui_shi_jian_fan_wei: 'Absoluter Zeitbereich',
      xiang_dui_shi_jian_fan_wei: 'Relativer Zeitbereich',
      kai_shi_shi_jian: 'Startzeit',
      jie_su_shi_jian: 'Endzeit',
      zui_jin_wu_fen_zhong: 'Letzte 5 Minuten',
      zui_jin_shi_wu_fen_zhong: 'Letzte 15 Minuten',
      zui_jin_san_shi_fen_zhong: 'Letzte 30 Minuten',
      zui_jin_yi_xiao_shi: 'Letzte Stunde',
      zui_jin_san_xiao_shi: 'Letzte 3 Stunden',
      zui_jin_liu_xiao_shi: 'Letzte 6 Stunden',
      zui_jin_shi_er_xiao_shi: 'Letzte 12 Stunden',
      zui_jin_er_shi_si_xiao_shi: 'Letzte 24 Stunden',
      zui_jin_liang_tian: 'Letzte 2 Tage',
      zui_jin_qi_tian: 'Letzte 7 Tage',
      zui_jin_san_shi_tian: 'Letzte 30 Tage'
    },
    bookmark: {
      biao_ti: 'Lesezeichen',
      xin_zeng_shu_qian: 'Lesezeichen hinzufügen',
      ming_cheng: 'Name',
      fu_gai: 'Überschreiben',
      chong_ming_ming: 'Umbenennen',
      shan_chu: 'Löschen',
      ming_cheng_xiu_gai_cheng_gong: 'Name erfolgreich geändert',
      xin_zeng: 'Hinzufügen',
      shan_chu_ti_shi: '[{name}] wirklich löschen?',
      shan_chu_cheng_gong: 'Erfolgreich gelöscht',
      xin_zeng_cheng_gong: 'Lesezeichen erfolgreich hinzugefügt!',
      tian_jia_ji_lu: 'Zur Historie hinzufügen',
      gong: 'Gesamt',
      tiao: 'Einträge',
      bao_cun: 'Speichern',
      qing_wan_cheng_zheng_zai_tian_jia_xiang: 'Bitte bestätigen Sie, dass der Eintrag hinzugefügt wird'
    },
    messageBox: {
      qing_shuru_yanzhengma: 'Bitte geben Sie den Verifizierungscode ein',
      yanzhengma_bu_zhengque: 'Falscher Verifizierungscode'
    },
    jsonEditor: {
      fuzhi: 'Kopieren'
    },
    cron: {
      second: 'Sekunde',
      minute: 'Minute',
      hour: 'Stunde',
      day: 'Tag',
      month: 'Monat',
      week: 'Woche',
      year: 'Jahr',
      cron_biaodashi_ziduan: 'Cron-Ausdrucksfeld',
      hanhua_fanyi: 'Deutsche Übersetzung',
      chongzhi: 'Zurücksetzen',
      single: 'pro ',
      mei_nian: 'pro Jahr',
      mei_yue: 'pro Monat',
      mei_ri: 'pro Tag',
      mei_tian: 'pro Tag',
      mei_shi: 'pro Stunde',
      xiaoshi: 'Stunde',
      mei_fenzhong: 'pro Minute',
      mei_miao: 'pro Sekunde',
      mei_zhou: 'pro Woche',
      cong: 'von',
      yue_qi_mei_ge: 'jeden Monat',
      ri_qi_mei_ge: 'jeden Tag',
      shi_qi_mei_ge: 'jede Stunde',
      fenzhong_qi_mei_ge: 'jede Minute',
      miao_qi_mei_ge: 'jede Sekunde',
      zuihou_yitian: 'letzter Tag',
      zhi: 'bis',
      cong_zhou: 'von Woche',
      zhi_zhou: 'bis Woche',
      qi_meige: 'jede',
      tian_zhixingyici: ' einmal pro Tag',
      xiaoshi_zhixingyici: ' einmal pro Stunde',
      yue_zhixingyici: ' einmal pro Monat',
      zhixingyici: ' einmal ausführen',
      ben_yue_di: 'dieser Monat',
      ben_yue: 'dieser Monat',
      xinqi: 'Woche',
      benyue_zuihou_yige_xingqi: 'Letzte Woche des Monats',
      buzhiding: 'Nicht festgelegt',
      zhouqi_cong: 'Zyklus von',
      xunhuan_cong: 'Schleife von',
      tip1: 'jeden Tag',
      tip2: 'der nächste Arbeitstag',
      tip3: 'beginnen, jede Stunde',
      tip4: 'beginnen, jeden Monat',
      tip5: 'Wochentag',
      benyue_zuihou_yitian: 'Letzter Tag des Monats',
      zhiding: 'Festlegen',
      kaishi: 'beginnen',
      kaishi_mei: 'beginnen jede',
      benyue: 'dieser Monat',
      mei: 'jede',
      zhixing: 'ausführen',
      zhouqi: 'Zyklus',
      di: 'Nr.',
      mess1: 'Datum und Woche können nicht gleichzeitig "nicht festgelegt" sein',
      mess2: 'Eines von Tag und Woche muss "nicht festgelegt" sein',
      zhouri: 'Sonntag',
      zhouyi: 'Montag',
      zhouer: 'Dienstag',
      zhousan: 'Mittwoch',
      zhousi: 'Donnerstag',
      zhouwu: 'Freitag',
      zhouliu: 'Samstag'
    },
    treeGraph: {
      fangda: 'Vergrößern',
      suoxiao: 'Verkleinern',
      shuaxin: 'Aktualisieren'
    }
  }
} 


// WEBPACK FOOTER //
// ./src/components/SimbartUI/lang/de-DE.js